import React from "react";
import { Link } from "react-router-dom";
import { useTraceabilityData } from "./contexts/TraceabilityDataContext";
import { useLocalStorage } from "@uidotdev/usehooks";

const TechnologyDrivenQualityTests = () => {
  const [storedName] = useLocalStorage("name", null);
  const { brandData, loading, errors } = useTraceabilityData();
  const brandName = brandData?.logo?.brandName || "[Brand Name]";
  const qualityData = [
    { label: "Fat %", value: "99.9%" },
    { label: "Moisture %", value: "0.3%" },
    { label: "FFA% (As Oleic Acid)", value: "0.5%" },
    { label: "BR Reading at 40°C", value: "41" },
    { label: "RM Value", value: "28" },
    { label: "Total Farmers", value: "44" },
    { label: "Total Milk Collected", value: "346 L" }
  ];
  return (
    <div className="bg-light">
      {/* Page Heading */}
      <div className="wrapper2">
        <h2 className="heading2">Technology-Driven Quality Tests</h2>
      </div>

      {/* Intro Section */}
      <section className="py-0">
        <div className="container py-0">
          <div className="row g-3">
            <div className="col-lg-4 col-12">
              <p className="card-text text-muted py-3 px-2">
                {loading.brand && "Loading brand information..."}
                {!loading.brand && errors.brand && "Error loading brand information."}
                {!loading.brand && !errors.brand && (
                  <>
                    At {brandName}, quality is our top priority. Every batch undergoes advanced testing, ensuring it meets stringent standards for safety and purity. From antibiotics to MBRT and E. coli, our thorough checks reflect our unwavering commitment to delivering only the best.
                  </>
                )}
              </p>
            </div>
          </div>
        </div>
      </section>

      <div className="wrapper2">
        <br />
        <h2 className="heading2" style={{ textAlign: "left" }}>Our Quality Tests</h2>
        <div className="underline2 my-3 mx-1"></div>
      </div>

      {/* Quality Tests */}
      <div className="bg-white py-8">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-2 gap-3 max-w-md mx-auto">
            {qualityData.map((item, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-green-500 to-green-700 rounded-xl p-3 text-white shadow-lg"
              >
                <div className="text-xs text-green-50 mb-1">
                  {item.label}
                </div>
                <div className="text-2xl font-bold">{item.value}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* <div className="container">
        <div className="underline2"></div>
      </div> */}

      {/* View Details Buttons */}
      {/* <section className="py-4 bg-white">
        <div className="container">
          <div className="row row-cols-2 row-cols-sm-2 row-cols-xl-4 justify-content-center px-2">
            <div className="col mb-4">
              <div className="text-center">
                <Link className="btn btn-success rounded-pill btn-lg" to="/meet-the-farmers-2">
                  <span className="px-1">View Farmer Details</span>
                </Link>
              </div>
            </div>

            <div className="col mb-4">
              <div className="text-center">
                <Link className="btn btn-success rounded-pill btn-lg" to="/meet-our-cows-2">
                  <span className="px-1">View Cattle Details</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* <div className="container p-3">
        <div className="underline2"></div>
      </div> */}

      {/* Quality Check Insights */}
      {/* <div className="bg-light">
        <div className="container p-3">
          <h6 className="card-title fw-bold my-2">Quality Check Insights</h6>

          <div className="row row-cols-xl-5 row-cols-lg-5 row-cols-md-3 row-cols-sm-3 row-cols-3 g-3">
            <Link to="/technology-driven-quality-tests">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list position-relative">
                  <img src="img/Technology-Driven Quality Tests_.png" alt="" className="card-img-top" />
                  <div className="position-absolute top-0 start-0 w-100 h-100" style={{ background: "rgba(0, 0, 0, 0.4)" }}></div>
                  <div className="position-absolute text-overlay-f text-white p-3" style={{ zIndex: 1, top: "25%" }}>
                    <h6 className="fw-normal" style={{ fontSize: "12px" }}>Technology-Driven Quality Tests</h6>
                  </div>
                </div>
              </div>
            </Link>

            <Link to="/sustainability-in-quality-assurance">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list position-relative">
                  <img src="img/Sustainability-in-Quality-Assurance_.png" alt="" className="card-img-top" />
                  <div className="position-absolute top-0 start-0 w-100 h-100" style={{ background: "rgba(0, 0, 0, 0.4)" }}></div>
                  <div className="position-absolute text-overlay-f text-white p-3" style={{ zIndex: 1, top: "25%" }}>
                    <h6 className="fw-normal" style={{ fontSize: "12px" }}>Sustainability in Quality Assurance<br /></h6>
                  </div>
                </div>
              </div>
            </Link>

            <Link to="/cloud-connectivity-quality">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list position-relative">
                  <img src="img/Cloud-Connectivity_.png" alt="" className="card-img-top" />
                  <div className="position-absolute top-0 start-0 w-100 h-100" style={{ background: "rgba(0, 0, 0, 0.4)" }}></div>
                  <div className="position-absolute text-overlay-f text-white p-3" style={{ zIndex: 1 }}>
                    <h6 className="fw-normal" style={{ fontSize: "12px" }}>Cloud Connectivity</h6>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div> */}

      <div className="flex justify-between mt-10 px-4 mb-4 gap-10 sm:px-0">
        <Link
          to="/milk-grading"
          className="bg-[#4c922b] text-white py-2 px-6 rounded-lg w-full sm:w-auto inline-block text-center no-underline hover:no-underline"
        >
          Previous
        </Link>
        <Link
          to="/empowering-farmers-and-communities"
          className="bg-[#4c922b] text-white py-2 px-6 rounded-lg w-full sm:w-auto inline-block text-center no-underline hover:no-underline"
        >
          Next
        </Link>

      </div>


      {/* <div className="container p-3">
        <div className="underline2"></div>
      </div> */}

      {/* Traceability Journey */}
      {/* <div className="wrapper2">
        <h2 className="heading2">Your Traceability Journey</h2>
      </div> */}

      {/* <div className="bg-light">
        <div className="container p-3">
          <div className="row row-cols-xl-5 row-cols-lg-5 row-cols-md-2 row-cols-2 g-3">
            <ProductItem
              href="dairy-farm"
              imageSrc="img/box1.png"
              stepNumber="01"
              title="Dairy Farms"
              description="Every batch begins with fresh milk collected from our trusted p2ers."
            />
            <ProductItem
              href="milk-grading"
              imageSrc="img/box2.png"
              stepNumber="02"
              title="Milk Grading"
              description="Ensuring fair pricing and top-quality milk through meticulous grading."
            />
            <ProductItem
              href="quality-check"
              imageSrc="img/box3.png"
              stepNumber="03"
              title="Quality Check"
              description="Rigorous testing of the milk to guarantee purity and freshness."
            />
            <ProductItem
              href="manufacturing"
              imageSrc="img/box4.png"
              stepNumber="04"
              title="Manufacturing"
              description="Advanced technology transforms raw milk into the highest quality product."
            />
            <ProductItem
              href="distribution"
              imageSrc="img/box5.png"
              stepNumber="05"
              title="Distribution"
              description="Delivering fresh products to you swiftly and efficiently."
            />
            <ProductItem
              href="it-is-you"
              imageSrc="img/box6.png"
              stepNumber="06"
              title={` It's ${storedName || "You"}! `}
              description="Fresh, quality products crafted with care and delivered with trust—just for you."
            />
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default TechnologyDrivenQualityTests;

